import { IDatabaseRecordBuilderBase } from "./IDatabaseRecordBuilderBase.js";

export interface IShardedDatabaseRecordBuilder extends IDatabaseRecordBuilderBase {

}
